export default "__VITE_ASSET__5EXWLXNj__"